/**
 * App
 */

// React
import React,{FC} from 'react';

// Router
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom';
import Refree from './routes';

// Components
import Auth from './components/Auth';

// UI
import {Container} from '@material-ui/core';
import Root from './pages/root';
import { Helmet } from 'react-helmet';
import {makeStyles, createStyles, Theme} from '@material-ui/core/styles';
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      display:'flex',
      '& .MuiContainer-maxWidthXl': {
        maxWidth: '100%',
      },
    },
  })
);

  const App:FC =(props:object)=>{
      const classes = useStyles();
    return (
      <Router>
        <Switch>
          <Route exact path="/" component={Root} />
          <Auth>
            <div className={classes.root} >
              <Refree/>
            </div>
            <Helmet>
              <script type="text/javascript">
                {(function (c, l, a, r, i, t, y) { c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments) }; t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i; y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y); })(window, document, "clarity", "script", "m88zf20sch")}
              </script>
            </Helmet>
          </Auth>
        </Switch>
      </Router>
    );
  }


export default App;
